import { useEffect } from "react";

import logConstituentActivityError from "@utils/logConstituentActivityError";
import MessageCard from "@components/elements/MessageCard";

const DEFAULT_NO_CONTENT_MESSAGE = "Sorry, we encountered an issue loading your data.";

export default function PageContent(props) {
  const {
    displayContent,
    noContentTitle = "No information found",
    noContentMessage = DEFAULT_NO_CONTENT_MESSAGE,
  } = props;

  useEffect(() => {
    if (displayContent) return;

    const isDataLoadFailure = noContentMessage === DEFAULT_NO_CONTENT_MESSAGE;

    if (isDataLoadFailure) {
      window.rollbar.error("PageContent: failed to load data");
    }

    logConstituentActivityError(isDataLoadFailure ? "Failed to load data" : noContentMessage);
  }, [displayContent, noContentMessage]);

  if (!displayContent) {
    return (
      <MessageCard title={noContentTitle}>
        {noContentMessage}
      </MessageCard>
    );
  } else {
    return (
      <>
        {props.children}
      </>
    );
  }
}
